/*
 * @Author       : suzhen
 * @Email        : suzhen@dianzhong.com
 * @Date         : 2022-09-19 11:42:43
 * @LastEditors: suzhen suzhen@dianzhong.com
 * @LastEditTime: 2024-02-20 17:07:39
 * @Description  : cookie验证
 */
import Cookies from 'js-cookie'
const UserIdKey = 'token'

const expires = 365

// function getDomain(){
//   let path = location.host.split('.')
//   if(isNaN(path[0] - 0)){ // 测试预发线上
//     path =  '.' + path.slice(1).join('.')
//   } else { // 本地环境
//     path = null
//   }
//   return path
// }

// token
export function getUserId() {
  return Cookies.get(UserIdKey)
}

export function setUserId(id) {
  return Cookies.set(UserIdKey, id, {expires})
}

export function removeUserId() {
  return Cookies.remove(UserIdKey)
}

// 手机号
export function getPhone() {
  return Cookies.get('user-phone')
}

export function setPhone(value) {
  return Cookies.set('user-phone', value, {expires})
}

// 用户Id
export function getUserNum() {
  return Cookies.get('user-num')
}

export function setUserNum(value) {
  return Cookies.set('user-num', value, {expires})
}

/**
 * @description: 本地存储
 * @param { String } key 名称
 * @param { any } value  value
 * @return {*}
 */
export function setStorage(key, value) {
  if(!value) return false
  if(typeof value == 'string' || typeof value == 'number') {
    localStorage.setItem(key, value)
  } else {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      console.log(error)
    }
  }
}

/**
 * @description: 读取本地存储
 * @param { String } key 名称
 * @param { Boolean } isObject 值是否是对象
 * @return {*} 有返回值
 */
export function getStorage(key,isObject) {
  if(!key) return false
  try {
    let data = localStorage.getItem(key) || ''
    if(isObject) {
      if(data) data = JSON.parse(data)
      else data = {}
    }
    return data
  } catch (error) {
    console.log(error)
  }
}

export function removeStorage(key) {
  localStorage.removeItem(key)
}

// 绘画存储
export function setSessionStorage(key, value) {
  if(!value) return false
  if(typeof value == 'string' || typeof value == 'number') {
    sessionStorage.setItem(key, value)
  } else {
    try {
      sessionStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      console.log(error)
    }
  }
}

export function getSessionStorage(key,isObject) {
  if(!key) return false
  try {
    let data = sessionStorage.getItem(key)
    if(isObject) {
      data = JSON.parse(data)
    }
    return data
  } catch (error) {
    console.log(error)
  }
}

export function removeAllStorage() {
  try {
    localStorage.clear();
    Cookies.remove(UserIdKey)
  } catch (error) {
    console.log(error)
  }
}

export function removeSessionStorage(key) {
  sessionStorage.removeItem(key)
}

